module.exports = __webpack_public_path__ + "static/media/issue-tracking.93e7fef7.svg";